import {
  rememberPostLoginReturnPath,
  sanitizeInternalReturnPath,
  syncPostLoginReturnPathFromLocationSearch,
} from './postLoginReturnPath';
import { notifyAuthSessionChanged } from './authSession';

let sessionExpiredRedirectScheduled = false;

export function isSessionExpiredRedirectScheduled() {
  return sessionExpiredRedirectScheduled;
}

/**
 * Clears auth, remembers the current URL for post-login redirect, then hard-navigates to /login.
 * Idempotent: safe from axios 401, JWT middleware, etc., until the document unloads.
 *
 * When already on `/login?returnUrl=…`, the full path is rejected by sanitize (auth route).
 * We must preserve the query string and sync the inner return target into sessionStorage.
 */
export function redirectToLoginAfterSessionExpired() {
  if (typeof window === 'undefined') return;
  if (sessionExpiredRedirectScheduled) return;
  sessionExpiredRedirectScheduled = true;

  const path = window.location.pathname;
  const search = window.location.search || '';
  const pathAndSearch = `${path}${search}`;

  rememberPostLoginReturnPath(pathAndSearch);

  if (path === '/login' && search.length > 0) {
    syncPostLoginReturnPathFromLocationSearch(search);
  }

  const returnPath = sanitizeInternalReturnPath(pathAndSearch);

  try {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    notifyAuthSessionChanged();
  } catch (e) {
    // ignore
  }

  let dest;
  if (returnPath) {
    dest = `/login?returnUrl=${encodeURIComponent(returnPath)}`;
  } else if (path === '/login' && search) {
    dest = `${path}${search}`;
  } else {
    dest = '/login';
  }
  window.location.assign(dest);
}
